import * as React from "react";

const AutomotiveIcon: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
        >
            <g clipPath="url(#clip0_630_13275)">
                <path
                    d="M8.04 4.5a1.515 1.515 0 00-1.43 1.031L5.46 9H0v6.164a1.493 1.493 0 001.125 1.453l1.946.493A3 3 0 006 19.5c1.389 0 2.549-.96 2.883-2.25h6.984c.334 1.29 1.494 2.25 2.883 2.25s2.549-.96 2.883-2.25h.867c.82 0 1.5-.68 1.5-1.5v-2.813a3.008 3.008 0 00-2.18-2.882l-3.398-.961-2.93-3.516A2.992 2.992 0 0013.195 4.5H8.04zm0 1.5h2.46v3H7.031L8.04 6zM12 6h1.195c.445 0 .864.197 1.149.54L16.406 9H12V6zM1.5 10.5h16.383l3.539 1.008a1.47 1.47 0 011.078 1.43v2.812h-.867c-.334-1.29-1.494-2.25-2.883-2.25s-2.549.96-2.883 2.25H8.883C8.549 14.46 7.389 13.5 6 13.5c-1.33 0-2.446.879-2.836 2.086L1.5 15.165V10.5zM6 15c.838 0 1.5.662 1.5 1.5S6.838 18 6 18s-1.5-.662-1.5-1.5S5.162 15 6 15zm12.75 0c.838 0 1.5.662 1.5 1.5s-.662 1.5-1.5 1.5-1.5-.662-1.5-1.5.662-1.5 1.5-1.5z"
                    fill="#000"
                />
            </g>
            <defs>
                <clipPath id="clip0_630_13275">
                    <path fill="#fff" d="M0 0H24V24H0z" />
                </clipPath>
            </defs>
        </svg>
    )
};
export default React.memo(AutomotiveIcon);
